import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { List } from "@remo-co/ui-core/src/components/List";
import { ListItemIcon } from "@remo-co/ui-core/src/components/ListItemIcon";
import { ListItem } from "@remo-co/ui-core/src/components/ListItem";
import { ListItemText } from "@remo-co/ui-core/src/components/ListItemText";
import { useI18n } from "i18n";
import { styles } from "./styles";
import benefitBulletPoint from "../../assets/trial-benefit-bullet-point.png";

const TrialFeaturesList = (): JSX.Element => {
  const { t } = useI18n("company");

  return (
    <Container sx={styles.infoBoxContainer} fullWidth={false}>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <Typography variant="h2">🎉</Typography>
      <Typography variant="h2">
        {t("company:trial.info.box.heading")}
      </Typography>
      <Typography variant="subtitle1" sx={styles.disclaimer}>
        {t("company:trial.info.box.disclaimer")}
      </Typography>
      <List sx={styles.infoBoxList}>
        {[
          "company:trial.info.box.benefit.1",
          "company:trial.info.box.benefit.2",
          "company:trial.info.box.benefit.3",
          "company:trial.info.box.benefit.4",
          "company:trial.info.box.benefit.5",
          "company:trial.info.box.benefit.6",
        ].map((key) => (
          <ListItem key={key} sx={styles.infoBoxListItem}>
            <ListItemIcon>
              <img src={benefitBulletPoint} alt="Benefit bullet point" />
            </ListItemIcon>
            <ListItemText
              sx={styles.infoBoxListItemText}
              primary={<Typography variant="h4">{t(key)}</Typography>}
            />
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default TrialFeaturesList;
